var _jsxFileName = "/src/main/react/src/main/app/components/common/Loading.js";
import React, { Component } from 'react';
import { Paper, Typography, Grid, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
const styles = () => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: '80vw',
    minWidth: '80vw'
  }
});
class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const classes = this.props.classes;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Paper, {
      style: {
        marginTop: '1vh',
        width: '100%'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      style: {
        width: '100%',
        height: '100%'
      },
      alignContent: "center",
      alignItems: "center",
      justify: "center",
      direction: "column",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      style: {
        width: '100%',
        height: '100%'
      },
      alignContent: "center",
      alignItems: "center",
      justify: "center",
      direction: "row",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32,
        columnNumber: 33
      }
    }))))));
  }
}
export default withStyles(styles)(Loading);